import React from 'react'

import styled from 'styled-components'

import { colors } from '../../constants/colors'
import { FlexColumn } from '../projectComponents'

const Block = styled(FlexColumn)<{ $color?: string; $selected?: boolean }>`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 100%;
  box-sizing: border-box;
  background-color: ${({ $color }) => $color || colors.lightPrimary};
  border: 1px solid #5a5a5a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  img {
    width: 14px;
    filter: drop-shadow(0 0 1px #5a5a5a);
  }
`

interface ColorButtonProps {
  clickOnColor: any
  color: string
  id: number
  label?: string
  selected: boolean
}

export const ColorButton: React.FC<ColorButtonProps> = ({
  clickOnColor,
  color,
  id,
  label,
  selected,
}) => {
  return (
    <Block
      $color={color}
      $selected={selected}
      aria-label={label || color}
      aria-pressed={selected}
      tabIndex={0}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          clickOnColor(id)
        }
      }}
      onClick={() => clickOnColor(id)}
      role="button"
      title={label || color}
    >
      {selected && <img alt={''} src={'/images/buttons/checkmark.svg'} />}
    </Block>
  )
}
